import React from "react";
import { makeStyles, createStyles, useTheme } from "@material-ui/core/styles";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Divider from "@material-ui/core/Divider";
import WhiteBoard from "./WhiteBoard";
import { toggleWhiteBoard } from "../../actions/whiteBoardActions";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      zIndex: 999999,
      backgroundColor: theme.palette.background.paper,
    },
    drawerHeader: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: "flex-start",
    },
  })
);

const MeetingDrawer = () => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();

  return (
    <div className={classes.root}>
      <div className={classes.drawerHeader}>
        <IconButton onClick={() => dispatch(toggleWhiteBoard())}>
          {theme.direction === "rtl" ? (
            <ChevronLeftIcon />
          ) : (
            <ChevronRightIcon />
          )}
        </IconButton>
        <Typography variant="h5">
          <FormattedMessage
            id="tooltip.whiteboard"
            defaultMessage="White Board"
          />
        </Typography>
      </div>
      <Divider />
      <WhiteBoard />
    </div>
  );
};

export default MeetingDrawer;
